

































  import {Vue, Component, Prop} from 'nuxt-property-decorator'

  @Component
  export default class LayoutSelect extends Vue {

  @Prop()
  value!: any

  selection: any

  mounted () {
    this.selection = this.value
  }

  options = [
      {
          name: 'Standard left aligned spotlight',
          value: 'standard-left',
          icon: 'layout-standard-left'
      },
      {
          name: 'Standard right aligned spotlight',
          value: 'standard-right',
          icon: 'layout-standard-right'
      },
      {
          name: 'Large left aligned spotlight',
          value: 'impact-left',
          icon: 'layout-impact-left'
      },
      {
          name: 'Large right aligned spotlight',
          value: 'impact-right',
          icon: 'layout-impact-right'
      }
  ]

  selectOption(value) {
    this.selection = value
    this.$emit('input', this.selection)
  }

  getPairs(arr) {
    return arr.reduce(
      (pairs, val) => {
        let lastPairIndex = pairs.length - 1
        if (pairs[lastPairIndex].length < 2) {
          pairs[lastPairIndex].push(val)
        } else {
          pairs.push([val])
        }
        return pairs
      },
      [[]]
    )
  }
}
